<template>
  <div class="availability-filter">
    <div class="availability-filter__label">Find available desks:</div>
    <div class="availability-filter__group">
      <app-date-select :date="from" class="date-control mr-1 px-0" @change="setDate('from', $event)"></app-date-select>
      <app-time-select :time="from.format('HH:mm')" class="time-control" @change="setTime('from', $event)"></app-time-select>
    </div>
    <span class="mx-2 availability-filter__delimiter">&ndash;</span>
    <div class="availability-filter__group">
      <app-date-select :date="to" class="mr-1 ml-0 px-0 date-control" @change="setDate('to', $event)"></app-date-select>
      <app-time-select :time="to.format('HH:mm')" class="time-control" @change="setTime('to', $event)"></app-time-select>
    </div>
    <div class="availability-filter__actions">
      <span
        class="ion ion-md-checkmark close-icon ml-3"
        :class="{ 'opacity-50': !haveChanges }"
        @click="emitChange"
        @touchend.stop.prevent="emitChange"
      ></span>
      <span class="ion ion-md-close close-icon ml-3" @click="close" @touchend.stop.prevent="close"></span>
    </div>
  </div>
</template>

<script>
import AppDateSelect from '@/components/shared/AppDateSelect'
import AppTimeSelect from '@/components/shared/AppTimeSelect'
import dayjs from 'dayjs'
import { SERVER_DATE_TIME_FORMAT } from '@/components/desk/utils'

export default {
  name: 'MapAvailabilityFilter',
  components: {
    AppDateSelect,
    AppTimeSelect
  },
  data() {
    const from = dayjs()
    const to = dayjs().add(1, 'w')
    return {
      haveChanges: true,
      from,
      to
    }
  },
  methods: {
    setDate(field, date) {
      this[field] = date.hour(this[field].hour()).minute(this[field].minute())
      this.haveChanges = true
    },
    setTime(field, time) {
      this[field] = this[field].hour(time.hour).minute(time.minute)
      this.haveChanges = true
    },
    emitChange() {
      const payload = {
        from: this.from.format(SERVER_DATE_TIME_FORMAT),
        to: this.to.format(SERVER_DATE_TIME_FORMAT)
      }
      this.$emit('change', payload)
      this.haveChanges = false
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.availability-filter {
  background-color: white;
  border-radius: 5px;
  padding: 0.5rem 0.7rem;
  box-shadow: 0 0 0.25rem #0000003f;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 0;
  margin-right: 1rem;

  @media (max-width: 715px) {
    max-width: 400px;
  }

  &__label {
    margin-right: 0.5rem;
    font-weight: bold;
    @media (max-width: 630px) {
      display: none;
    }
  }

  &__actions {
    text-align: right;
  }

  &__group {
    display: flex;
  }

  &__delimiter {
    font-weight: bold;
    @media (max-width: 630px) {
      display: none;
    }
  }
}

.date-control {
  width: 120px;
}

.time-control {
  width: 66px;
}
</style>
